import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The bar above team pages behind the Elevation gate (Design Language, the
 * Lab, the Method, the Workbook and the rest; see lib/elevationAccess.ts).
 * The Elevation header is a menu of the owner's own pages, so team pages get
 * this instead: the way back to the team hub at /home, and, for the owner
 * only, the way into Elevation. Same paper ground, hairline rule and
 * wide-tracked caps as ProductDesignDocsNav.
 *
 * `actions` sit at the right end, after the Elevation link: Design Language
 * puts its light/dark switch there (features/design-language).
 */
const LINK_CLASS =
  'font-body text-[13px] font-medium uppercase tracking-[0.2em] text-[var(--p-label)] whitespace-nowrap transition-colors hover:text-[var(--p-ink)]';

export const TeamHomeBar: React.FC<{ showElevation: boolean; actions?: React.ReactNode }> = ({
  showElevation,
  actions,
}) => {
  const elevation = showElevation && (
    <Link to="/elevation/home" className={LINK_CLASS}>
      Elevation
    </Link>
  );
  return (
    <nav aria-label="Team" className="border-b border-[var(--p-hairline)] bg-[var(--p-paper)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-[52px] flex items-center justify-between gap-4">
        <Link to="/home" className={LINK_CLASS}>
          ← Team home
        </Link>
        {actions ? (
          <div className="flex items-center gap-4">
            {elevation}
            {actions}
          </div>
        ) : (
          elevation
        )}
      </div>
    </nav>
  );
};
